const CAMPAIGN_PRODUCT_MAP = {
  'Thuk Gyi Gadi BOGO Sale Blush And Mood Collection Gift Set for Her': ['eyebrow-growth-oil-with-castor-brhami-and-vitamin-e', 'd-i-v-a-woman-100ml'],
  'BOGO2Test': ['night-fever-100ml', 'vanilla-gourmet-collection'],
};

const getCookie = name => document.cookie.split(';').find(c => c.trim().startsWith(name + '='))?.split('=')[1];
const getURLParam = name => new URLSearchParams(window.location.search).get(name);
const getHandle = item => item.getAttribute('data-product-handle') || item.href?.match(/\/products\/([^?#/]+)/)?.[1];

let container = null;
let campaign = null;
let campaignProducts = null;

function findContainer() {
  const grid = document.getElementById('ProductGridContainer') || document.querySelector('.ProductGridContainer') || document.querySelector('ul[role="list"]');
  if (!grid) return null;
  return grid.tagName === 'UL' ? grid : grid.querySelector('ul[role="list"]');
}

function reorderProducts() {
  if (!container || !campaign || !campaignProducts) return;
  
  const items = container.querySelectorAll('li.grid__item');
  if (items.length === 0) return;

  const matched = [];
  const unmatched = [];

  items.forEach(item => {
    const link = item.querySelector('a[data-product-handle]') || item.querySelector('a');
    const handle = getHandle(link);
    
    if (handle && campaignProducts.includes(handle)) {
      matched.push({ item, idx: campaignProducts.indexOf(handle) });
    } else {
      unmatched.push(item);
    }
  });

  if (matched.length > 0) {
    matched.sort((a, b) => a.idx - b.idx);
    const frag = document.createDocumentFragment();
    matched.forEach(m => frag.appendChild(m.item));
    unmatched.forEach(item => frag.appendChild(item));
    container.appendChild(frag);
  }
}

function setupObserver() {
  if (!container) return;

  let debounceTimer;
  const obs = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reorderProducts, 50);
  });

  obs.observe(container, { childList: true });
}

const tryInit = () => {
  if (!window.location.pathname.includes('/collections/v-day-sale')) return;
  
  if (!campaign) {
    campaign = getURLParam('utm_campaign') || getCookie('ck_utm_campaign') || '';
    if (campaign && CAMPAIGN_PRODUCT_MAP[campaign]) {
      campaignProducts = CAMPAIGN_PRODUCT_MAP[campaign];
    }
  }
  
  if (!container) {
    container = findContainer();
    if (container) setupObserver();
  }
  
  reorderProducts();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tryInit, { once: true });
} else {
  tryInit();
}

document.addEventListener('shopify:section:load', tryInit);
document.addEventListener('shopify:section:reorder', tryInit);



// Custom Collection Filter - Scroll to top functionality
(function() {
  'use strict';
  
  const SCROLL_DELAY = 100;
  const REMOVE_BUTTON_OFFSET = 25;
  let facetFiltersCache = null;
  
  function isFilterSticky() {
    if (!facetFiltersCache) {
      facetFiltersCache = document.querySelector('.facet-filters');
    }
    if (!facetFiltersCache) return false;
    return window.getComputedStyle(facetFiltersCache).position === 'sticky';
  }
  
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  
  function handleCheckboxChange(e) {
    if (e.target.type === 'checkbox' && isFilterSticky()) {
      setTimeout(scrollToTop, SCROLL_DELAY);
    }
  }
  
  function handleRemoveClick(e) {
    if (!e.target.classList.contains('facet-checkbox')) return;
    
    const rect = e.target.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    
    // Check if click is on the × pseudo-element area (right side)
    if (clickX <= rect.width - REMOVE_BUTTON_OFFSET) return;
    
    e.stopPropagation();
    e.preventDefault();
    
    const checkbox = e.target.querySelector('input[type="checkbox"]');
    if (checkbox?.checked) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  
  function init() {
    const customFilter = document.querySelector('.custom-collection-filter');
    if (!customFilter) return;
    
    customFilter.addEventListener('change', handleCheckboxChange, true);
    customFilter.addEventListener('click', handleRemoveClick);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
